import type { BeneficiaryListItemPayload } from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiariesFetched';

/**
 * The directory reuses the list-item wire shape (`GET …/beneficiaries`), though only `id`, `firstName`
 * and `lastName` are read: the route answers the same envelope regardless of purpose, and declaring a
 * narrower shape here would silently drift from what the server actually sends.
 */
export type BeneficiaryDirectoryFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly BeneficiaryListItemPayload[];
};

export type BeneficiaryDirectoryFetchedAction = {
	type: 'BENEFICIARY_DIRECTORY_FETCHED';
	payload: BeneficiaryDirectoryFetchedPayload;
	facilityId: number;
	assignedUserId: number | null;
};

export default (
	payload: BeneficiaryDirectoryFetchedPayload,
	facilityId: number,
	assignedUserId: number | null,
): BeneficiaryDirectoryFetchedAction => ({
	type: 'BENEFICIARY_DIRECTORY_FETCHED',
	payload,
	facilityId,
	assignedUserId,
});
